module.exports = __webpack_public_path__ + "media/images/icons/chevron-up-5b83e7745fd03c7a00cde735ac48fe80.svg";